// extracted by mini-css-extract-plugin
export default {"aboutSca":"aboutSca_aboutSca__a7skF"};